import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const confirmActionAuthorization = unaryRpc({
  name: "confirmActionAuthorization",
  input: z.object({ token: z.string().min(1) }),
  output: z.object({
    status: z.enum(["confirmed", "already_confirmed", "expired_or_unknown"]),
  }),
});
